<template>
  <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="machineType"
    :saveMethod="saveChanges">
    <template v-slot:content="{ item, editMode, handleFocus }">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <QTextField :value="item.Id" :label="$t('servicesystem.common_objects.machine_type.id')" disabled>
            </QTextField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.machine_type.name')" maxlength="50"
              :rules="[requiredRule]" :externaledit="editMode" @FocusState="handleFocus">
            </QTextField>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </EntityEditCard>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";

export default {
  name: "MachineTypeDetails",
  props: {
    machineType: Object,
  },
  components: {
    EntityEditCard,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      const dto = Object.assign({}, obj);
      await this.updateMachineType(dto)
        .then((response) => {
          this.$emit("Set", response);
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>